const CAMPAIGN_DETAIL_TEMPLATE = {
  displayMode: {
    name: {
      type: "text",
      label: "Name",
      modelKey: "name",
      display: false,
    },
    type: {
      type: "select",
      displayStyle: "text",
      label: "Campaign Type",
      availableInModel: true,
      url: "field_options/",
      queryParams: {
        content_type: "campaign",
        field_name: "type",
        flat: "True",
      },
      modelKey: "type",
      display: true,
    },
  },
  editMode: [
    [
      {
        name: "name",
        type: "text",
        label: "Name",
        modelKey: "name",
        width: 100,
      },
    ],
    [
      {
        name: "type",
        type: "single-select-dropdown",
        label: "Campaign Type",
        availableInModel: true,
        url: "field_options/",
        queryParams: {
          content_type: "campaign",
          field_name: "type",
          flat: "True",
        },
        fetchStaticLabel: false,
        isURLBased: true,
        modelKey: "type",
        width: 100,
        dataFormatter: (data) => data?.map((item) => ({ id: item.key, label: item.label })) ?? [],
      },
    ],
  ],
};

export default CAMPAIGN_DETAIL_TEMPLATE;
